import { render, staticRenderFns } from "./RelationshipList.vue?vue&type=template&id=706b2b20&scoped=true&"
import script from "./RelationshipList.vue?vue&type=script&lang=js&"
export * from "./RelationshipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b2b20",
  null
  
)

export default component.exports